import {useCallback, useMemo, useState} from 'react';
import {t} from '../../../common/getTranslations';
import {requestContext} from '../../../common/requestContext';
import {Dialog} from '../../../design-system/organisms/Dialog';
import {useDialog} from '../../../dialog/useDialog.hook';
import {Maybe} from '../../../graphql/generated/types';

export function useWriteCommentBlockDialog() {
  const [blockedMsg, setBlockedMsg] = useState<Maybe<string>>('');

  const {showDialog, DialogWrapper, hideDialog} = useDialog({
    isMobile: requestContext.requestInfo.display.isMobile,
    onClose: () => setBlockedMsg(''),
  });

  const showBlockDialog = useCallback(
    (msg: Maybe<string> = '') => {
      setBlockedMsg(msg);
      showDialog();
    },
    [showDialog]
  );

  const blockDialogComponent = useMemo(() => {
    return (
      <DialogWrapper>
        <Dialog.Dimmed />
        <Dialog.Title>{t('comment_blocked_user_title')}</Dialog.Title>
        <Dialog.List>
          <Dialog.Label>
            {t('comment_blocked_user_details')}
            <br />
            {blockedMsg && (
              <Dialog.Label className="font-medium2-bold">
                {blockedMsg}
              </Dialog.Label>
            )}
          </Dialog.Label>
          <div className="flex flex-col">
            <Dialog.Caption>{t('comment_blocked_user_info_1')}</Dialog.Caption>
            <Dialog.Caption>{t('comment_blocked_user_info_2')}</Dialog.Caption>
            <Dialog.Caption>{t('comment_blocked_user_info_3')}</Dialog.Caption>
            <Dialog.Caption>{t('comment_blocked_user_info_4')}</Dialog.Caption>
          </div>
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button onClick={hideDialog}>
            {t('common_confirm_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </DialogWrapper>
    );
  }, [DialogWrapper, blockedMsg, hideDialog]);

  return {
    blockDialogComponent,
    showBlockDialog,
  };
}
